import React from 'react';
// Импортируем иконку (назови файл about.ico или поменяй название здесь)
import iconAbout from '../image/about.ico';
function About() {
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1 className="page-title">О компании Ironvector</h1>
        <p className="page-subtitle">Ваш технологический партнер с сильной инженерной экспертизой.</p>
      </div>
      
      <div className="card company-text" style={{ maxWidth: '800px', margin: '0 auto' }}>
        
        {/* Добавленный блок с иконкой */}
        <div className="service-icon" style={{ marginBottom: '20px' }}>
          <img src={iconAbout} alt="Инженерная экспертиза" />
        </div>
        <h3 className="tech-category" style={{ marginBottom: '16px' }}>Инженерный подход</h3>
        <p>Мы — команда специалистов, объединенных страстью к созданию надежного программного обеспечения. В основе нашей работы лежит глубоко выверенный инженерный опыт, который позволяет нам проектировать отказоустойчивую архитектуру для ИТ-систем любой сложности.</p>
        <p>Наше главное преимущество — высокая скорость выполнения задач. Мы избегаем избыточного кода и долгих бюрократических согласований. Вместо этого мы фокусируемся на быстром поиске оптимальных технических решений, будь то запуск современного веб-сервиса, интеграция нейросетей или разработка высокопроизводительного системного ПО для Windows на C++.</p>
        <p>Работая с нами, вы получаете не только качественный код в сжатые сроки, но и полностью прозрачный процесс разработки, предсказуемый результат и уверенность в стабильной работе вашего продукта.</p>
      </div>
    </div>
  );
}
export default About;